import React, { useState, useContext } from "react";
import Alert from "react-bootstrap/Alert";
import { Row, Col, Button } from "react-bootstrap";
import classes from "./NewNotification.module.css";
import { Link } from "react-router-dom";
import PermissionContext from "../../Store/permission-context";
function NewNotification() {
  const [show, setShow] = useState(true);
  const PCtx = useContext(PermissionContext);
  const Path = PCtx.ThePath;
  return (
    <>
      {show && (
        <Alert variant="danger" onClose={() => setShow(false)} dismissible>
          <Row className="justify-content-around">
            <Col md={6} lg={6} sm={12} xs={12}>
              <Alert.Heading className="mt-0 mb-0">Alas!</Alert.Heading>
              <p className={classes.AlertAppearanceParagraph}>
                Some Items will expire soon
              </p>
            </Col>
            <Col md={3} lg={3} sm={12} xs={12}>
              <div className="d-flex justify-content-end align-self-center  mt-2 mb-0">
                <Button
                  onClick={() => setShow(false)}
                  variant="outline-success"
                >
                  <Link to={"/" + Path + "expireditems"}>View all!</Link>
                </Button>
              </div>
            </Col>
          </Row>
        </Alert>
      )}
    </>
  );
}

export default NewNotification;
